export function getCyclesFromYear(fromYear: number) {
  const cycle = []
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()
  const currentMonth = currentDate.getUTCMonth()

  for (let year = fromYear; year < currentYear; year++) {
    const nextYear = year + 1
    cycle.push({
      value: `${year}_${nextYear}`,
      description: `${year}/${nextYear}`
    })
  }
  if (currentMonth > 5) {
    const nextYear = currentYear + 1
    cycle.push({
      value: `${currentYear}_${nextYear}`,
      description: `${currentYear}/${nextYear}`
    })
  }

  return cycle
}

export function threeJulianYearsBefore() {
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()
  const currentMonth = currentDate.getUTCMonth()

  return currentMonth > 5 ? currentYear - 3 : currentYear - 4
}

export function preferentCycleForModel() {
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()
  const currentMonth = currentDate.getUTCMonth()

  return currentMonth <= 4 ? `${currentYear - 2}_${currentYear - 1}` : `${currentYear - 1}_${currentYear}`
}
